import React from 'react';
import AppLayout from '../../layout/app.layout';
import ListShows from '../../components/shows/list-shows.component';
import PAGE_TITLE_LIST from '../../config/page-title.config';

const ContentShowsView = () => {
  const pageTitle = `${PAGE_TITLE_LIST.CONTENT_SHOWS}`;

  return (
    <AppLayout pageTitle={pageTitle}>
      <ListShows/>
    </AppLayout>
  );
};

export default ContentShowsView;
